export default __webpack_public_path__ + "static/Horseshoe Las Vegas - Meeting Space-5ffec5da1d63b405bd65fbe40685d600.pdf";